module.exports = __webpack_public_path__ + "assets/images/default_course_img.6bfab08bab4e3cc29958d057f60a7004.png";